/**
 * @generated SignedSource<<6a41ce353c1fbfcb9b34059e57d9a6b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef";
};
export type number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef$key = {
  readonly " $data"?: number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewNew_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "208597408b836a196e2e432d65098e64";

export default node;
